import React, {useContext} from 'react';
import CustomButton from "../../../general_components/LoadingButton";
import {PRIMARY_COLOR, SECONDARY_COLOR, TERTIARY_COLOR, WHITE} from "../../../constants/Colors";
import {nexusFourBedImage, nexusThreeBedImage} from "./ChartData";
import {ChartContext} from "../../../contexts/ChartContext";
import useResponsive from "../../../hooks/useResponsive";


export default function NexusButtons({selected, setSelected, setData, setImage}) {

    const isMobile = useResponsive('down', 'md');
    const chartContext = useContext(ChartContext);
    const { nexusThreeBedData, nexusFourBedData,} = chartContext

    return (
        <div style={{display: 'flex', marginTop: 20}}>
            <CustomButton
                text={'3 Bedrooms'}
                style={{
                    backgroundColor: selected === '3 Bed' ? TERTIARY_COLOR : WHITE,
                    boxShadow: 'none',
                    borderRadius: 0,
                    fontWeight: 'normal',
                    height: 50,
                    '&:hover': {
                        boxShadow: 'none',
                        backgroundColor:  TERTIARY_COLOR,
                    },
                    color: selected === '3 Bed' ? '#fff' : SECONDARY_COLOR,
                    fontSize: 16,
                    border: `1px solid ${selected === '3 Bed' ? TERTIARY_COLOR : SECONDARY_COLOR}`,
                    width: isMobile ? 'auto' : 180,
                    marginRight: 10
                }}
                sx={{
                    zIndex: 100,
                    fontFamily: 'MontserratRegular !important',
                    fontWeight: 200
                }}
                onClick={() => {
                    setSelected('3 Bed')
                    setData(nexusThreeBedData);
                    setImage(nexusThreeBedImage)
                }}
            />
            <CustomButton
                text={'4 Bedrooms'}
                style={{
                    backgroundColor: selected === '4 Bed' ? TERTIARY_COLOR : WHITE,
                    boxShadow: 'none',
                    borderRadius: 0,
                    fontWeight: 'normal',
                    height: 50,
                    '&:hover': {
                        boxShadow: 'none',
                        backgroundColor:  TERTIARY_COLOR,
                    },
                    color: selected === '4 Bed' ? '#fff' : SECONDARY_COLOR,
                    fontSize: 16,
                    border: `1px solid ${selected === '4 Bed' ? TERTIARY_COLOR : SECONDARY_COLOR}`,
                    width: isMobile ? 'auto' : 180,
                }}
                sx={{
                    zIndex: 100,
                    fontFamily: 'MontserratRegular !important',
                    fontWeight: 200
                }}
                onClick={() => {
                    setSelected('4 Bed')
                    setData(nexusFourBedData)
                    setImage(nexusFourBedImage)
                }}
            />
        </div>
    );
}
